import { render, staticRenderFns } from "./AnnullaBollettini.vue?vue&type=template&id=3113913f"
import script from "./AnnullaBollettini.vue?vue&type=script&lang=js"
export * from "./AnnullaBollettini.vue?vue&type=script&lang=js"
import style0 from "./AnnullaBollettini.vue?vue&type=style&index=0&id=3113913f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports